export default __webpack_public_path__ + "imgs/0efe2024b8cf54d5f51969f30dabc243.jpg";